import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { filter, take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class TokenRefreshService {
  private _isRefreshing = false;
  private _refreshTokenSubject = new BehaviorSubject<string | null>(null);

  isRefreshInProgress(): boolean {
    return this._isRefreshing;
  }

  startRefresh(): void {
    this._isRefreshing = true;
    this._refreshTokenSubject.next(null);
  }

  completeRefresh(newToken: string): void {
    this._isRefreshing = false;
    this._refreshTokenSubject.next(newToken);
  }

  failRefresh(): void {
    this._isRefreshing = false;
    this._refreshTokenSubject.next(null);
    this._refreshTokenSubject = new BehaviorSubject<string | null>(null);
  }

  waitForRefresh(): Observable<string | null> {
    return this._refreshTokenSubject.pipe(
      filter(token => token !== null),
      take(1)
    );
  }
}